// @ts-nocheck
import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useStoreActions } from "easy-peasy";
import { post } from "requests";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import PipelineAvatar from "./PipelineAvatar";
import { Divider, Typography, Chip } from "@mui/material";
import { get } from "requests";
import {
  AddToPhotos,
  AutoMode,
  Brightness1,
  ChangeCircle,
  ContentCopy,
  ContentCopyOutlined,
  ContentCopyRounded,
  ContentCopySharp,
  ContentCopyTwoTone,
  Email,
  FileCopy,
  FileCopyOutlined,
  GpsFixed,
  JoinFull,
  JoinFullOutlined,
  JoinFullRounded,
  JoinFullTwoTone,
  JoinInner,
  Layers,
  ModeStandby,
  OfflineBolt,
  RadioButtonChecked,
  Repeat,
  Stars,
  SwapHoriz,
  SwapHorizontalCircle,
  Tonality,
  TripOrigin,
  Warning,
} from "@mui/icons-material";

function PipelineCard({
  data,
  index,
  status,
  onUpdateStatus,
  allowedColumns,
  onFetchAllowedColumns,
  onDragEnd,
  refreshApplications,
  onDragStart,
  isDragging,
  applications,
  editableRoles,
  assignableRoles,
}) {
  const navigate = useNavigate();

  const [showAllDuplicates, setShowAllDuplicates] = useState(false);

  const handleShowMoreClick = () => {
    setShowAllDuplicates(!showAllDuplicates);
  };

  const duplicateApplications = useMemo(() => {
    if (!data?.duplicateApplications) return [];
    return data.duplicateApplications
      .split(",")
      .map((app) => app.trim())
      .filter(Boolean)
      .filter((appNo) => appNo !== data.applicationNo);
  }, [data?.duplicateApplications]);

  return (
    <Box
      borderRadius={2}
      boxShadow={3}
      mb={2}
      className="pipeline-item"
      draggable
      onDragStart={(e) => onDragStart(e, data.id, status)}
      onDoubleClick={() => navigate(`/deal_applications/${data.id}`)}
      style={{
        opacity: isDragging ? 0.3 : 1,
      }}
    >
      <Box p={1} paddingBottom={0}>
        <div
          style={{
            borderBottom: "1px solid lightgray",
            paddingBottom: "1px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div
              className={"size-14"}
              style={{
                whiteSpace: "normal",
                color: status?.toLowerCase() !== "declined" ? "#2F929F" : "#F9A199",
                fontWeight: "500",
              }}
            >
              {data.merchantName || "NA"}
            </div>
            {data.broker && <div className={"size-12"}>{`ISO: ${data.broker || ""}`}</div>}
          </div>

          <Box display="flex" alignItems="center" gap={1}>
            {data.newEmail === "true" && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  borderRadius: "50%",
                  width: 28,
                  height: 28,
                  position: "relative",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
                title="New Email Available"
              >
                <Email
                  sx={{
                    color: "#2F929F",
                    fontSize: "16px",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: -1,
                    right: -1,
                    minWidth: 16,
                    height: 16,
                    backgroundColor: "#1A73E8",
                    borderRadius: "50%",
                    border: "1px solid #fff",
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "#fff",
                    lineHeight: 1,
                  }}
                >
                  1
                </Box>
              </Box>
            )}

            {status?.toLowerCase() !== "declined" && (
              <PipelineAvatar
                data={data}
                refreshApplications={refreshApplications}
                editableRoles={editableRoles}
                assignableRoles={assignableRoles}
              />
            )}
          </Box>
        </div>

        <Box mt={1} className="pipeline-item-meta size-14">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span
              style={{
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "140%",
                letterSpacing: "0%",
                color: "#344767",
                fontFamily: "Roboto",
                textTransform: "capitalize",
              }}
            >
              REPRESENTATIVE:
            </span>{" "}
            &nbsp;
            <span
              className="float-right color-secondary"
              style={{
                maxWidth: "60%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "right",
                display: "inline-block",
                color: "#7B809A !important",
                fontFamily: "Roboto",
                lineHeight: "140%",
                letterSpacing: "0%",
              }}
              title={data.representativeName}
            >
              {data.representativeName}
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span
              style={{
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "140%",
                letterSpacing: "0%",
                color: "#344767",
                fontFamily: "Roboto",
                textTransform: "capitalize",
              }}
            >
              FUNDER:
            </span>{" "}
            &nbsp;
            <span
              className="float-right color-secondary"
              style={{
                maxWidth: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "right",
                display: "inline-block",
                fontFamily: "Roboto",
                lineHeight: "140%",
                letterSpacing: "0%",
              }}
              title={data.funder}
            >
              {data.funder}
            </span>
          </div>
          <div>
            <span
              style={{
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "140%",
                letterSpacing: "0%",
                color: "#344767",
                fontFamily: "Roboto",
                textTransform: "capitalize",
              }}
            >
              DATE STARTED:
            </span>{" "}
            <span
              className="float-right color-secondary"
              style={{
                maxWidth: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "right",
                display: "inline-block",
                color: "#7B809A !important",
                fontFamily: "Roboto",
                lineHeight: "140%",
                letterSpacing: "0%",
              }}
            >
              {data.applicationDate}
            </span>
          </div>
        </Box>

        {duplicateApplications?.length > 0 && (
          <Box
            sx={{
              marginX: "-3px",
              padding: "7px 4px",
              marginTop: "6px",
              marginBottom: "3px",
              backgroundColor: "rgba(211, 47, 47, 0.05)",
              borderRadius: "0 8px 8px 0",
              position: "relative",
              "&:before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(90deg, rgba(211, 47, 47, 0.03) 0%, rgba(211, 47, 47, 0) 100%)",
                pointerEvents: "none",
                borderRadius: "0 8px 8px 0",
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={0.5}
              sx={{
                pr: 1.5,
                borderRadius: 1,
                mb: 1,
                width: "fit-content",
              }}
            >
              <Layers
                sx={{
                  color: "rgba(211, 47, 47, 0.75) !important",
                  fontSize: "20px !important",
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: "rgba(211, 47, 47, 0.75)",
                  fontSize: "0.75rem",
                  lineHeight: 1.5,
                  letterSpacing: "0.025em",
                  display: "flex",
                  gap: "8px",
                }}
              >
                <span>DUPLICATE APPS</span>
                <span>({duplicateApplications.length})</span>
              </Typography>
            </Box>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                marginTop: "10px",
                paddingLeft: "17px",
              }}
            >
              {(showAllDuplicates || duplicateApplications.length === 2
                ? duplicateApplications
                : duplicateApplications.slice(0, 1)
              ).map((app, index) => (
                <Box
                  key={index}
                  bgcolor={"rgba(211, 47, 47, 0.5)"}
                  style={{
                    padding: "3px 8px",
                    borderRadius: "16px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontSize: "12px",
                      fontWeight: 500,
                      textAlign: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const selectedItem = applications.find((item) => item.applicationNo === app);

                      if (selectedItem && selectedItem?.id) {
                        navigate(`/deal_applications/${selectedItem.id}`);
                      }
                    }}
                  >
                    {app}
                  </div>
                </Box>
              ))}

              {duplicateApplications.length > 2 && !showAllDuplicates && (
                <Box
                  bgcolor="#e0e0e0"
                  style={{
                    padding: "4px 10px",
                    borderRadius: "16px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={handleShowMoreClick}
                >
                  <div
                    style={{
                      color: "#424242",
                      fontSize: "12px",
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    +{duplicateApplications.length - 1} more
                  </div>
                </Box>
              )}

              {showAllDuplicates && duplicateApplications.length > 2 && (
                <Box
                  bgcolor="#e0e0e0"
                  style={{
                    padding: "4px 10px",
                    borderRadius: "16px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={handleShowMoreClick}
                >
                  <div
                    style={{
                      color: "#424242",
                      fontSize: "12px",
                      fontWeight: 500,
                      textAlign: "center",
                    }}
                  >
                    Show less
                  </div>
                </Box>
              )}
            </div>
          </Box>
        )}
      </Box>

      <Box
        bgcolor={
          status?.toLowerCase() !== "declined"
            ? "rgba(47, 146, 159, 0.5)"
            : "rgba(244, 67, 52, 0.5)"
        }
        style={{
          padding: "2px 7px",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          marginTop: duplicateApplications?.length > 0 ? 0 : 8,
        }}
      >
        <div className={"pipeline-item-id"}>
          {`APP ID: `}
          <span
            style={{
              fontSize: 14,
              fontWeight: "bold",
              lineHeight: "140%",
              letterSpacing: "0%",
              color: "#344767",
              fontFamily: "Roboto",
              textTransform: "capitalize",
              color: "white",
            }}
          >
            {data.applicationNo}
          </span>
        </div>
      </Box>
    </Box>
  );
}

function DataPipeline({ applications, columns, filterComponent }) {
  const [groupedApplications, setGroupedApplications] = useState({});
  const [allowedColumns, setAllowedColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);
  const [assignableRoles, setAssignableRoles] = useState<string[]>([]);
  const [editableRoles, setEditableRoles] = useState<string[]>([]);

  const VISIBLE_ITEMS = 10;

  const containerRef = useRef(null);

  const fetchApplications = useStoreActions((actions) => actions.applications.fetchApplications);

  const [visibleItems, setVisibleItems] = useState(() => {
    const initial = {};
    columns?.forEach((col) => {
      initial[col] = VISIBLE_ITEMS;
    });
    return initial;
  });

  const columnRefs = useRef({});

  useEffect(() => {
    const fetchAssignableRoles = async () => {
      try {
        const roles = await get("getAssignableRoles");
        setAssignableRoles(roles);
        setEditableRoles([...roles, "DELETE ROLE"]);
      } catch (error) {
        console.error("Error fetching assignable roles:", error);
      }
    };

    fetchAssignableRoles();
  }, []);

  useEffect(() => {
    const grouped = applications.reduce((acc, app) => {
      const subStatus = app.subStatusName ? app.subStatusName.toUpperCase() : "";
      if (!acc[subStatus]) {
        acc[subStatus] = [];
      }
      acc[subStatus].push(app);
      return acc;
    }, {});
    setGroupedApplications(grouped);
  }, [applications]);

  const updateCardStatus = useCallback(
    async (applicationId, newStatus) => {
      const autoAssignUserRoles = async () => {
        try {
          const userId = localStorage.getItem("logInUserId");
          const roleName = localStorage.getItem("roleName");

          if (applicationId && userId && roleName) {
            const request: any = {
              applicationId: applicationId,
              currentUserId: userId,
              roleName: roleName,
            };

            await post("autoAssignRoles", request);
          }
        } catch (error) {
          console.error("Error auto assigning roles:", error);
        }
      };

      try {
        setIsLoading(true);
        await post("/dealApplication/updateSubstatus", {
          dealApplicationId: applicationId,
          subStatusName: newStatus,
        });
        await autoAssignUserRoles();
        fetchApplications();
      } catch (error) {
        console.error("Error updating card status:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchApplications]
  );

  const fetchAllowedColumns = useCallback(async (applicationId) => {
    try {
      const response = await post("/steps/getStepsArrayByDealApplicationId", {
        id: applicationId,
      });
      setAllowedColumns(response);
    } catch (error) {
      console.error("Error fetching allowed columns:", error);
    }
  }, []);

  const clearAllowedColumns = useCallback(() => {
    setAllowedColumns([]);
  }, []);

  const filteredAndGroupedApplications = useMemo(() => {
    const grouped = {};

    applications.forEach((app) => {
      const status = app.subStatusName ? app.subStatusName.toUpperCase() : "";
      if (!grouped[status]) {
        grouped[status] = [];
      }
      grouped[status].push(app);
    });

    return grouped;
  }, [applications]);

  const paginatedApplications = useMemo(() => {
    return Object.keys(filteredAndGroupedApplications).reduce((acc, status) => {
      acc[status] = filteredAndGroupedApplications[status].slice(
        0,
        visibleItems[status] || VISIBLE_ITEMS
      );
      return acc;
    }, {});
  }, [filteredAndGroupedApplications, visibleItems]);

  const handleDragStart = (e, id, status) => {
    fetchAllowedColumns(id);
    setDraggedItem({ id, status });
    e.dataTransfer.setData("text/plain", id);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    handleDragMove(e);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    clearAllowedColumns();
  };

  const handleDragLeave = () => {
    setDraggedItem(null);
    clearAllowedColumns();
  };

  const handleDrop = (e, status) => {
    e.preventDefault();
    if (draggedItem && allowedColumns.includes(status)) {
      updateCardStatus(draggedItem.id, status);
    }
    clearAllowedColumns();
    setDraggedItem(null);
  };

  const handleDragMove = useCallback(
    (e) => {
      if (!containerRef.current || !draggedItem) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const mouseX = e.clientX;
      const scrollSpeed = 100;
      const edgeThreshold = 150;

      const shouldScrollLeft = mouseX < rect.left + edgeThreshold;
      const shouldScrollRight = mouseX > rect.right - edgeThreshold;

      if (shouldScrollLeft) {
        container.scrollLeft -= scrollSpeed;
      } else if (shouldScrollRight) {
        container.scrollLeft += scrollSpeed;
      } else {
      }
    },
    [draggedItem]
  );

  const handleColumnScroll = (status) => {
    const column = columnRefs.current[status];
    if (!column) return;

    const { scrollTop, scrollHeight, clientHeight } = column;
    const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;

    if (isNearBottom) {
      setVisibleItems((prev) => ({
        ...prev,
        [status]: (prev[status] || VISIBLE_ITEMS) + VISIBLE_ITEMS,
      }));
    }
  };

  return (
    <div style={{ height: "calc(100vh - 13vh)" }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        style={{ padding: "0px 8px 1px 0px" }}
      >
        {filterComponent ? filterComponent : null}
      </MDBox>

      <Box position="relative" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        {isLoading && (
          <div
            className="loader"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <Box
          display="flex"
          overflow="auto"
          ref={containerRef}
          onMouseMove={handleDragMove}
          whiteSpace="nowrap"
          style={{ scrollBehavior: "smooth" }}
        >
          {columns?.map((status) => (
            <div
              key={status}
              width={300}
              style={{
                width: 300,
                paddingLeft: "8px",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingRight: "0px",
                display: "inline-block",
              }}
              display="inline-block"
              className={
                "pipeline-column " +
                (status === "DECLINED" ? "pipeline-column-declined " : "") +
                (allowedColumns?.length && !allowedColumns.includes(status) ? "bg-gray " : "")
              }
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, status)}
              onDragEnd={handleDragEnd}
            >
              <div
                className="pipeline-column-header"
                style={
                  allowedColumns.length && !allowedColumns.includes(status)
                    ? { filter: "blur(1.5px)" }
                    : {}
                }
              >
                {`${status} (${filteredAndGroupedApplications[status]?.length || 0})`}
              </div>
              <div
                className="pipeline-content"
                ref={(el) => (columnRefs.current[status] = el)}
                onScroll={() => handleColumnScroll(status)}
              >
                {paginatedApplications[status]?.map((app, index) => (
                  <PipelineCard
                    key={app.id}
                    data={app}
                    index={index}
                    status={status}
                    onUpdateStatus={updateCardStatus}
                    allowedColumns={allowedColumns}
                    onFetchAllowedColumns={() => {}}
                    onDragEnd={() => handleDragEnd}
                    refreshApplications={fetchApplications}
                    onDragStart={handleDragStart}
                    isDragging={draggedItem && draggedItem.id === app.id}
                    applications={applications}
                    editableRoles={editableRoles}
                    assignableRoles={assignableRoles}
                  />
                ))}
              </div>
            </div>
          ))}
        </Box>
      </Box>
    </div>
  );
}

export default DataPipeline;
